import script from "./DevicePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicePreview.vue?vue&type=script&setup=true&lang=js"

import "./DevicePreview.vue?vue&type=style&index=0&id=80e86192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e86192"]])

export default __exports__